<template>
  <div id="main-container">
    <sideBar :update="updateCalendar" />
    <dialogError :error="getError" />
    <programPopin ref="program" :update="updateCalendar" :dateSelected="date" />
    <div id="planner-container">
      <div id="day-selector-container" v-if="getCurrentVehicle">
        <div id="day-selector">
          <v-btn class="navigate-btn" @click="$refs.calendar.prev()">
            <v-icon size="27" class="icon-navigation">mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn class="navigate-btn" @click="$refs.calendar.next()">
            <v-icon size="27" class="icon-navigation">mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn id="today-btn" @click="setToday"
            ><span id="today-btn-text">{{ $t("planning.today") }}</span></v-btn
          >
        </div>
        <h2 id="date-title" v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </h2>
        <div id="calendar-type-selector">
          <div
            @click="changeType('month')"
            :class="{ 'type-btn': true, 'type-btn-active': type === 'month' }"
          >
            Mois
          </div>
          <div
            @click="changeType('week')"
            :class="{ 'type-btn': true, 'type-btn-active': type === 'week' }"
          >
            Semaine
          </div>
          <div
            @click="changeType('day')"
            :class="{ 'type-btn': true, 'type-btn-active': type === 'day' }"
            id="day-btn"
          >
            Jour
          </div>
        </div>
      </div>
      <div id="add-program-btn" @click="addProgram()" v-if="getCurrentVehicle">
        {{ $t("soc-requirement.add-program") }}
      </div>
      <v-calendar
        v-if="getCurrentVehicle"
        v-model="date"
        id="calendar"
        ref="calendar"
        :weekday-format="myDayFormat"
        :type="type"
        :events="events"
        :interval-format="intervalFormat"
        event-color="#E7F3FF"
        event-text-color=" #10367a"
        @change="updateEvents"
        @click:event="showProgram"
        @click:date="clickDay"
        event-more-text="{0} de plus"
        :weekdays="weekdays"
        :locale="locale"
      ></v-calendar>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapActions, mapGetters } from 'vuex'
import sideBar from '@/components/vehicle-side-bar.vue'
import dialogError from '@/components/base-error-dialog.vue'
import programPopin from '@/components/add-program.vue'
import getEnv from '@/utils/env'

export default {
  data: () => ({
    date: '',
    type: 'month',
    period: null,
    error: false,
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    dialog: false
  }),
  components: {
    sideBar,
    dialogError,
    programPopin
  },
  computed: {
    ...mapGetters('vehicle', ['getCurrentVehicle', 'getSocs', 'getError']),
    days () {
      return [this.$t('planning.sunday'), this.$t('planning.monday'), this.$t('planning.tuesday'), this.$t('planning.wednesday'), this.$t('planning.thursday'), this.$t('planning.friday'), this.$t('planning.saturday')]
    },
    locale () {
      return getEnv('VUE_APP_I18N_LOCALE')
    },
    events () {
      const events = []

      this.getSocs.forEach(event => {
        const first = moment(event.period.from).tz(this.getCurrentVehicle.timezone)
        const second = moment(event.period.to).tz(this.getCurrentVehicle.timezone)

        events.push({
          name: `${event.soc.toString()}%`,
          start: first.format('YYYY-MM-DD HH:mm'),
          end: second.format('YYYY-MM-DD HH:mm'),
          timed: true,
          id: event.id,
          soc: event.soc,
          recurrent: !!event.recurrent,
          days: event.days ? event.days : []
        })
      })
      return events
    }
  },
  methods: {
    ...mapActions('vehicle', ['getVehicleFleet', 'loadProgram', 'getVehicleChargeDistance']),
    addProgram () {
      this.$refs.program.open()
    },
    showProgram (e) {
      this.$refs.program.openExisting(e.event)
    },
    clickDay (e) {
      this.changeType('day')
    },
    setToday () {
      this.date = ''
    },
    myDayFormat (d) {
      return this.days[d.weekday]
    },
    changeType (type) {
      this.type = type
    },
    intervalFormat (interval) {
      return interval.time.substring(0, interval.time.length - 3).toString()
    },
    async updateEvents ({ start, end }) {
      this.period = { start, end }
      const from = new Date(`${start.date}T00:00:00`)
      const to = new Date(`${end.date}T23:59:59`)
      await this.loadProgram({ from, to })
      this.$refs.calendar.scrollToTime({ hour: 7, minute: 30 })
    },
    updateCalendar () {
      if (this.period) {
        this.updateEvents(this.period)
      }
    }
  }
}
</script>

<style>
.type-btn {
  height: 100%;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid #10367a 1px;
  border-right: none;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  color: #10367a;
}

.icon-navigation {
  color: white !important;
}

.v-calendar .v-event {
  width: 99% !important;
  margin-left: 2px !important;
  border: #10367a 1px solid !important;
}

.theme--light.v-calendar-events .v-event-more {
  margin-left: 5px;
}

.v-event-timed-container {
  margin-right: 0px !important;
}

.type-btn-active {
  background-color: #10367a;
  color: white;
}

.v-btn--contained {
  box-shadow: none;
  border-radius: 0px;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  background-color: #f7f7f78c !important;
  overflow: hidden;
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(0, 0, 0, 0.7);
  min-width: auto;
}

.v-calendar-weekly__day.v-outside {
  border-right: #10367a 1px solid !important;
}
.v-calendar-weekly__head-weekday {
  font-size: 16px !important;
  font-weight: bold;
  text-transform: none !important;
  color: white !important;
  background-color: #10367a !important;
}

.v-calendar-daily_head-weekday {
  font-size: 16px;
  font-weight: bold;
  text-transform: none;
  color: white !important;
  background-color: #10367a !important;
}

.theme--light.v-calendar-daily .v-calendar-daily_head-day {
  border: none;
}

.v-btn--fab.v-size--default {
  height: 36px;
  width: 36px;
}

.theme--light.v-calendar-daily .v-calendar-daily__intervals-head::after {
  background: none;
}

.theme--light.v-calendar-daily .v-calendar-daily__intervals-body {
  border-right: #10367a 1px solid !important;
}

.v-calendar-daily__intervals-head {
  border-right: #10367a 1px solid !important;
}

.theme--light.v-calendar-daily .v-calendar-daily__interval::after {
  border-top: #10367a 1px solid !important;
}

.v-calendar-daily_head-day-label {
  border-right: solid #10367a 1px !important;
  border-bottom: solid #10367a 1px !important;
  height: 45px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.v-calendar-daily__day-interval {
  border-top: solid #10367a 1px !important;
}

.theme--light.v-calendar-daily .v-calendar-daily__day {
  border-right: #10367a 1px solid !important;
  border-bottom: #10367a 1px solid !important;
}

.v-calendar-weekly__week {
  border-left: #10367a 1px solid !important;
}

.v-calendar-daily__interval-text {
  color: #10367a !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-color: #10367a !important;
}

.v-calendar-weekly__head-weekday {
  border-right: solid #10367a 1px !important;
  border-bottom: solid #10367a 1px !important;
}

.v-btn--round {
  color: #10367a !important;
  background-color: rgba(16, 137, 255, 0.1) !important;
}

/* customize scrollbar css */

.v-calendar-daily__scroll-area::-webkit-scrollbar {
  width: 11px;
  background-color: rgba(16, 136, 255, 0);
}
.v-calendar-daily__scroll-area::-webkit-scrollbar:horizontal {
  height: 11px;
}
.v-calendar-daily__scroll-area::-webkit-scrollbar-track {
  border: 1px rgba (16, 137, 255, 0.1) solid;
  border-radius: 10px;
  -webkit-box-shadow: 0 0 6px rgba(16, 136, 255, 0) inset;
  box-shadow: 0px;
}
.v-calendar-daily__scroll-area::-webkit-scrollbar-thumb {
  background-color: #10367a;
  border: 1px solid #10367a;
  border-radius: 16px;
}

#today-btn {
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  margin-left: 9px;
  cursor: pointer;
}

.navigate-btn {
  width: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  margin-right: 3px;
  color: white;
  cursor: pointer;
}

#today-btn-text {
  margin-right: 16px;
  margin-left: 16px;
  font-size: 16px;
  font-weight: bold;
  text-transform: none !important;
}

#add-program-btn {
  color: #10367a;
  font-size: 16px;
  margin: 22px;
  font-weight: bold;
  cursor: pointer;
}

#day-btn {
  border-right: solid #10367a 1px;
}

#date-title {
  color: #10367a;
  font-size: 20px;
  text-transform: capitalize;
}

#day-selector {
  height: 100%;
  display: flex;
}

#calendar-type-selector {
  height: 100%;
  display: flex;
}

#calendar {
  border: none;
  height: 100px;
  flex: 1 1 auto;
}

#day-selector-container {
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

#main-container {
  display: flex;
  height: 100%;
}

#planner-container {
  width: 100%;
  margin-left: 59px;
  margin-right: 98px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
}
</style>
